import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromRoomingDataStore from './state/rooming-data-store.reducer';

/* effects */
import { RoomingDataStoreEffects } from './state/rooming-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* RoomingDataStore State */
    StoreModule.forFeature(
      fromRoomingDataStore.featureKey,
      fromRoomingDataStore.reducer,
      { initialState: fromRoomingDataStore.initialState },
    ),
    EffectsModule.forFeature([RoomingDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class RoomingDataStoreModule {}
